<template>
  <div class="animated-logo" :class="getClass">
  <svg viewBox="0 0 312 35" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_658_1037)">
      <path d="M99.5381 15.5343L105.541 8.28809H103.483C103.298 8.28809 103.1 8.33545 102.978 8.52151L98.9798 14.6987L97.9676 13.2305C95.0216 8.97482 95.2738 8.28809 93.5822 8.28809H90.1385L96.4946 17.4659L89.8862 25.4462H91.9713C92.2134 25.4462 92.4018 25.3718 92.5161 25.1959L97.0696 18.3015L98.6469 20.5444C101.489 24.5768 101.105 25.4733 103.244 25.4462H106.473L99.5381 15.5377V15.5343Z" fill="white"/>
      <path d="M89.5511 12.121C89.2653 11.2989 88.8483 10.5716 88.2833 9.93562C87.725 9.29963 86.9751 8.80911 86.0536 8.45052C85.1254 8.09193 84.0526 7.91602 82.8285 7.91602C80.2793 7.91602 78.2783 8.74821 76.8288 10.4126C75.3727 12.0804 74.6698 14.2962 74.7101 17.0634C74.7438 19.2758 75.2751 21.468 76.6943 23.2305C78.211 25.1148 80.629 25.7913 82.9529 25.7913C85.2767 25.7913 87.8629 24.9896 89.1678 23.792C89.6655 23.332 89.4099 22.7467 89.161 22.537C87.725 23.6736 86.2352 24.2217 84.3216 24.2217C82.4081 24.2217 81.1873 23.5992 80.4037 22.3543C79.6201 21.1094 79.1998 19.1101 79.1359 16.3496H89.7832C89.8303 16.3496 89.8673 16.3158 89.8773 16.2718C89.9715 15.832 90.0119 15.3483 90.0018 14.8341C89.9883 13.8429 89.8404 12.9363 89.5545 12.1176L89.5511 12.121ZM86.0099 15.0134L79.1022 15.5276C79.1964 13.0716 79.6706 8.88691 82.9058 8.88691C85.9393 8.8903 86.0267 12.7028 86.0065 15.0134H86.0099Z" fill="white"/>
      <path d="M72.0448 13.4302C72.0448 9.99989 70.7366 7.91602 67.3971 7.91602C65.0262 7.91602 62.7998 9.02899 61.2024 10.7205C61.2024 9.39435 60.9838 8.28814 59.6958 8.28814H56.9751L57.1399 10.2468L57.1332 23.4707L56.9751 25.4429H61.3941L61.2293 23.4707V11.6677C62.4938 10.7069 63.6742 10.1961 65.3826 10.1961C67.5282 10.1961 67.9486 12.1954 67.9486 14.4349V23.1256C67.9486 24.5836 68.2883 25.4463 69.4889 25.4463H72.2096L72.0448 23.4876V13.4336V13.4302Z" fill="white"/>
      <path d="M50.4478 5.52433C51.6652 5.52433 52.6539 4.5399 52.6539 3.32881C52.6539 2.11773 51.6652 1.1333 50.4478 1.1333C49.2304 1.1333 48.2383 2.11773 48.2383 3.32881C48.2383 4.5399 49.227 5.52433 50.4478 5.52433Z" fill="white"/>
      <path d="M52.6511 10.6054C52.6511 9.28266 52.409 8.28809 51.1142 8.28809H48.3936L48.5583 10.2468V23.4706L48.3936 25.4429H52.8126L52.6478 23.4706V10.6054H52.6511Z" fill="white"/>
      <path d="M44.2225 13.4302C44.2225 9.96268 42.911 7.91602 39.5748 7.91602C36.7533 7.91602 34.8532 9.35037 33.3465 10.964C32.7916 9.03914 31.4834 7.91602 28.9309 7.91602C26.5499 7.91602 24.5926 9.04929 23.0153 10.7441V10.7205C23.0153 9.39435 22.7967 8.28814 21.5053 8.28814H18.7847L18.9495 10.2468V23.4707L18.7847 25.4429H23.207L23.0456 23.4707V11.6677C24.2731 10.6291 25.7562 10.1961 26.9602 10.1961C29.2806 10.1961 29.5261 12.6149 29.5261 14.4315V23.4707L29.3681 25.4429H33.7871L33.6223 23.4707V11.6677C34.6884 10.7408 36.1715 10.1961 37.557 10.1961C39.975 10.1961 40.123 12.8314 40.123 14.4315V23.1222C40.123 24.7596 40.5905 25.4429 41.6633 25.4429H44.384L44.2192 23.4707V13.4302H44.2225Z" fill="white"/>
      <path d="M4.95862 5.81864C4.96534 3.73815 6.42489 2.34438 8.98415 2.34438C10.4605 2.34438 11.8461 2.65561 13.2417 3.31528C14.2439 3.79227 14.8123 3.12922 15.1486 2.33085C13.1879 1.53248 11.197 1.1333 9.16575 1.1333C4.95862 1.1333 0.569878 2.53383 0.539611 7.44244C0.509344 14.0899 11.8393 14.9288 12.105 20.4633C12.2362 23.1053 10.3428 24.5668 7.7331 24.5668C5.91708 24.5668 4.27929 24.1879 2.65495 23.332C1.74357 22.855 1.1046 23.4132 0.764933 24.1811C2.56751 25.2298 5.57068 25.7948 7.59858 25.7948C12.6095 25.7948 16.7796 23.7785 16.6384 18.7989C16.4467 11.8977 4.93507 11.1061 4.96198 5.81526L4.95862 5.81864Z" fill="white"/>
    </g>
    <path d="M136.073 19.9288L140.692 25.0366H137.785L134.845 21.7983C133.004 24.202 130.419 25.7043 127.609 25.7043C123.215 25.7043 119.694 22.6663 119.694 18.8939C119.694 15.8893 121.826 13.3188 125.638 11.7831V11.6162C123.894 9.8468 123.021 8.14421 123.021 6.475C123.021 3.43704 125.993 1 129.709 1C132.519 1 134.877 2.40213 136.493 5.0061L135.524 5.8407C134.134 3.67073 132.196 2.50229 129.999 2.50229C127.447 2.50229 125.606 4.1715 125.606 6.44162C125.606 7.77699 126.22 9.04558 127.576 10.5479L135.136 18.8939C135.879 17.425 136.364 15.7558 136.493 14.0198H137.72C137.559 16.1898 136.977 18.1928 136.073 19.9288ZM128.158 24.202C130.29 24.202 132.39 22.8666 133.941 20.7968L126.607 12.6511C123.829 14.0532 122.278 16.2232 122.278 18.727C122.278 21.7983 124.863 24.202 128.158 24.202Z" fill="#AE955F"/>
    <g clip-path="url(#clip1_658_1037)">
      <path d="M235.946 18.3686V16.6308C235.957 10.5429 232.743 7.82974 227.892 7.82227H227.804C220.367 7.87085 219.608 14.609 219.605 16.728C219.594 23.7913 223.124 26.2653 227.779 26.3849C227.921 26.3849 228.038 26.4185 228.18 26.4185C231.138 26.426 234.592 24.9872 235.771 20.7492H231.116C230.773 22.0086 229.478 22.6813 228.187 22.6813H227.786C224.514 22.4459 224.259 19.6467 224.259 18.3499H227.79L235.946 18.3686ZM227.801 11.6155H227.83C229.267 11.6155 231.076 12.505 231.328 15.3303L227.793 15.3228H224.262C224.525 13.0207 225.674 11.6118 227.801 11.6118" fill="white"/>
      <path d="M214.117 2.2119L214.084 26.0439L218.622 26.0504L218.655 2.21839L214.117 2.2119Z" fill="white"/>
      <path d="M205.893 7.78889C205.408 7.78889 204.974 7.81879 204.573 7.87485C202.446 8.28594 201.469 9.63507 200.746 10.7824H200.692V8.22241L196.329 8.21493L196.296 32.9888L200.834 32.9963L200.845 23.6084L200.932 23.6346C201.392 24.4605 202.282 25.8694 204.551 26.2618C204.923 26.3179 205.324 26.3814 205.787 26.3852C210.898 26.3926 213.09 21.7735 213.093 16.945C213.104 10.8272 209.716 7.79263 205.897 7.78516M204.554 22.5583H204.438C201.509 22.5545 200.681 19.2845 200.681 17.1991C200.684 14.4 201.695 11.784 204.569 11.7877C207.669 11.7914 208.439 14.6504 208.435 17.4757C208.432 20.0656 207.338 22.4723 204.554 22.5583Z" fill="white"/>
      <path d="M170.428 8.18139L170.406 25.862L174.94 25.8695L174.954 15.013C174.954 13.1294 175.651 11.6308 177.774 11.6308C180.072 11.6308 180.499 13.7535 180.499 15.2559L180.48 25.877H184.989L185.003 15.2895C185.003 13.2004 185.842 11.642 188.14 11.642C189.431 11.642 190.58 12.5315 190.577 15.1475L190.562 25.8882H195.071L195.089 13.6564C195.092 9.79586 192.51 7.76283 189.121 7.75909C186.368 7.75909 185.098 9.69122 184.555 10.547C183.351 8.69339 182.228 7.74788 179.733 7.74414C176.691 7.74414 175.454 9.62395 174.874 10.7675H174.786L174.794 8.17766L170.428 8.17018V8.18139Z" fill="white"/>
      <path d="M170.436 2.00009L170.431 6.29785L174.775 6.30329L174.78 2.00552L170.436 2.00009Z" fill="white"/>
      <path d="M168.724 13.7689C168.389 8.76484 164.366 7.90902 161.01 7.90529C155.637 7.89781 154.058 11.2202 154.054 13.8063C154.047 20.4286 164.73 18.2087 164.727 21.1462C164.727 21.7964 164.18 22.9998 161.823 22.9961C158.978 22.9923 158.092 21.8712 158.095 20.3688L153.438 20.3613C153.43 25.0739 157.793 26.4866 161.699 26.4978C164.398 26.4978 169.224 25.5972 169.231 20.4473C169.239 13.9184 158.468 15.9589 158.471 13.1635C158.471 12.4011 158.788 11.4295 161.258 11.4295C163.731 11.4369 164.129 12.644 164.3 13.7615L168.721 13.7689H168.724Z" fill="white"/>

      <g class="wine">
        <g class="animated-logo__letter" style="--sibling-index: 0">
          <path d="M257.974 9.76041V7.43164H266.344V9.78781H263.268L257.713 25.6371H254.076L249.885 14.3015L245.583 25.6371H241.823L237.371 9.76041H235.453V7.43164H244.337V9.76041H241.933L244.7 20.6645L249.289 7.47959H252.289L256.905 20.6645L260.282 9.76041H257.974Z" fill="white"/>
        </g>
        <g class="animated-logo__letter" style="--sibling-index: 1">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M270.878 23.3701H273.74V25.6299H263.309V23.3633H266.344V7.43164H270.878V23.3701ZM270.885 1V5.3291H266.351V1H270.885Z" fill="white"/>
        </g>
        <g class="animated-logo__letter" style="--sibling-index: 2">
          <path d="M287.309 7.03418C293.015 7.03418 293.248 10.3561 293.248 13.0684L293.254 13.0753V23.3767H296.056V25.6438H286.782V23.3767H288.713V14.4041C288.713 11.9725 288.549 10.404 285.782 10.404C284.042 10.404 282.076 11.226 281.145 11.6575V23.363H283.809V25.6301L273.741 25.6438L273.741 23.3698H276.604V9.78761H273.83V7.43144H281.042V9.65747C282.343 8.69172 284.275 7.03418 287.309 7.03418Z" fill="white"/>
        </g>
        <g class="animated-logo__letter" style="--sibling-index: 3">
          <path d="M311.947 15.6986C311.947 11.4383 309.775 7.02734 304.152 7.02734C298.885 7.02734 295.241 10.8287 295.241 16.8082C295.241 22.7876 299.419 26 304.878 26C308.056 26 310.406 24.3904 311.577 23.1233L310.385 20.8561C309.228 21.678 307.536 22.4589 305.714 22.4589C302.522 22.4589 300.166 21.2191 299.981 17.0616H311.954V15.6917L311.947 15.6986ZM299.871 14.8356C299.974 11.9041 301.138 9.56844 303.741 9.56844C306.515 9.56844 307.132 11.7534 307.132 14.8356H299.865H299.871Z" fill="white"/>
        </g>
      </g>
      <g class="prime">
        <g class="animated-logo__letter2" style="--sibling-index: 0">
          <path d="M240.312 8.12477V11.5181H240.382C240.878 10.2699 241.684 9.30572 242.8 8.62555C243.916 7.94538 245.185 7.60156 246.604 7.60156C247.936 7.60156 249.088 7.85569 250.069 8.36395C251.051 8.87221 251.868 9.55985 252.521 10.4269C253.174 11.2939 253.659 12.2992 253.976 13.4428C254.29 14.5864 254.45 15.7935 254.45 17.0641C254.45 18.3348 254.293 19.5419 253.976 20.6855C253.659 21.8291 253.177 22.8344 252.521 23.7014C251.868 24.5684 251.051 25.2486 250.069 25.7456C249.088 26.2427 247.932 26.4893 246.604 26.4893C245.973 26.4893 245.342 26.4071 244.711 26.2464C244.08 26.0857 243.493 25.8428 242.953 25.5177C242.413 25.1963 241.932 24.7889 241.516 24.3068C241.1 23.821 240.775 23.2567 240.553 22.6101H240.484V32.5884H238.354V8.12477H240.316H240.312ZM251.995 14.3061C251.78 13.3942 251.441 12.5795 250.981 11.862C250.518 11.1444 249.927 10.5614 249.205 10.113C248.483 9.66076 247.615 9.43652 246.601 9.43652C245.43 9.43652 244.449 9.64581 243.657 10.0606C242.869 10.4755 242.238 11.0323 241.764 11.7237C241.29 12.4151 240.958 13.226 240.765 14.1491C240.571 15.0722 240.476 16.0439 240.476 17.0604C240.476 17.9835 240.582 18.9028 240.797 19.8147C241.013 20.7266 241.359 21.5413 241.844 22.2588C242.329 22.9764 242.96 23.5594 243.737 24.0078C244.514 24.46 245.466 24.6843 246.593 24.6843C247.607 24.6843 248.476 24.46 249.198 24.0078C249.92 23.5556 250.511 22.9726 250.974 22.2588C251.437 21.5413 251.773 20.7303 251.988 19.8147C252.203 18.9028 252.309 17.9835 252.309 17.0604C252.309 16.1373 252.203 15.218 251.988 14.3061H251.995Z" fill="white"/>
        </g>
        <g class="animated-logo__letter2" style="--sibling-index: 1">
          <path d="M258.707 8.12493V12.3181H258.776C259.316 10.8643 260.155 9.74314 261.297 8.95833C262.435 8.17352 263.792 7.81475 265.371 7.88575V10.0683C264.401 10.0234 263.522 10.1542 262.734 10.4682C261.946 10.7783 261.264 11.2231 260.687 11.8023C260.111 12.3816 259.666 13.0655 259.352 13.8653C259.035 14.6613 258.878 15.5358 258.878 16.4813V26.0074H256.748V8.12493H258.71H258.707Z" fill="white"/>
        </g>
        <g class="animated-logo__letter2" style="--sibling-index: 2">
          <path d="M268.548 3.64746H266.418V7.14547H268.548V3.64746Z" fill="white"/>
        </g>
        <g class="animated-logo__letter2" style="--sibling-index: 2">
          <path d="M268.548 8.125H266.418V26.0037H268.548V8.125Z" fill="white"/>
        </g>
        <g class="animated-logo__letter2" style="--sibling-index: 3">
          <path d="M272.031 8.125L277.51 23.8212H277.576L282.985 8.125H285.184L278.659 26.0037H276.394L269.664 8.125H272.031Z" fill="white"/>
        </g>
        <g class="animated-logo__letter2" style="--sibling-index: 4">
          <path d="M287.84 20.095C288.056 20.9396 288.398 21.6945 288.873 22.3635C289.347 23.0324 289.941 23.5893 290.664 24.0265C291.386 24.4638 292.254 24.6843 293.268 24.6843C294.822 24.6843 296.04 24.2694 296.919 23.436C297.798 22.6026 298.407 21.4964 298.747 20.1099H300.877C300.424 22.143 299.596 23.7126 298.393 24.8225C297.185 25.9325 295.478 26.4856 293.268 26.4856C291.893 26.4856 290.704 26.2352 289.701 25.7419C288.698 25.2448 287.88 24.5647 287.249 23.6976C286.618 22.8306 286.152 21.8253 285.845 20.6817C285.542 19.5382 285.389 18.331 285.389 17.0604C285.389 15.8832 285.542 14.7284 285.845 13.596C286.148 12.4636 286.618 11.4546 287.249 10.5652C287.88 9.6757 288.698 8.95816 289.701 8.41627C290.704 7.87438 291.893 7.60156 293.268 7.60156C294.643 7.60156 295.861 7.88933 296.853 8.46859C297.846 9.04786 298.652 9.80277 299.272 10.7371C299.892 11.6714 300.337 12.7477 300.607 13.9585C300.877 15.1694 300.99 16.4026 300.946 17.6471H287.523C287.523 18.4319 287.629 19.2467 287.844 20.0913L287.84 20.095ZM298.389 13.4241C298.13 12.6617 297.765 11.9853 297.291 11.3985C296.817 10.8081 296.244 10.3372 295.566 9.97842C294.891 9.61965 294.121 9.44026 293.268 9.44026C292.414 9.44026 291.612 9.61965 290.933 9.97842C290.259 10.3372 289.682 10.8118 289.208 11.3985C288.734 11.989 288.358 12.6692 288.074 13.4428C287.793 14.2164 287.607 15.0087 287.516 15.8159H298.809C298.787 14.9825 298.644 14.1865 298.385 13.4241H298.389Z" fill="white"/>
        </g>
        <g class="animated-logo__letter2" style="--sibling-index: 4">
          <path d="M291.002 6.25666L294.096 2H296.733L292.724 6.25666H291.002Z" fill="white"/>
        </g>
      </g>
    </g>
    <defs>
      <clipPath id="clip0_658_1037">
        <rect width="107.418" height="25.5757" fill="white"/>
      </clipPath>
      <clipPath id="clip1_658_1037">
        <rect width="159" height="33" fill="white" transform="translate(152.969)"/>
      </clipPath>
    </defs>
  </svg>
  </div>
</template>
<script setup lang="ts">
import { ref, computed, onMounted, onUnmounted, type ComputedRef } from 'vue';

defineOptions({
  name: 'HeaderLogo'
})
const classes:string[] = ['up','up-wait','down','down-wait'];
const state:string|null = ref(null);


const getClass:ComputedRef<string> = computed(()=>{
  return state.value ?? ''
})

let intervalId: number | undefined;
let currentIndex = 3;

// 4. Function to start interval
const startInterval = () => {
  if(!window){
    return;
  }
  intervalId = window.setInterval(() => {
    currentIndex = (currentIndex + 1) % classes.length;
    state.value = classes[currentIndex];
  }, 5000); // Changes class every 1 second
};
onMounted(()=>{
  setTimeout(()=>{
    startInterval();
  },6000)

})
</script>
<style  lang="scss">
.animated-logo{
      &__letter {
        path {
          animation: none;
          transform: translateY(0%);
        }
      }

      &__letter2 {
        path {
          animation: none;
          transform: translateY(100%);
        }
      }
  &.up-wait{
    .animated-logo__letter path{
      animation: none;
      transform: translateY(-100%);
      opacity: 0;
    }
    .animated-logo__letter2 path{
      animation: none;
      transform: translateY(0%);
      opacity: 1;
    }
  }
  &.down-wait{
    .animated-logo__letter path{
      animation: none;
      transform: translateY(0%);
      opacity: 1;
    }
    .animated-logo__letter2 path{
      animation: none;
      transform: translateY(100%);
      opacity: 0;
    }
  }
  &.up{
    .animated-logo__letter path{
      animation-name: letterTransformUp1;
      animation-duration: 1s;
      animation-timing-function: linear;
      animation-direction: normal;
      animation-fill-mode: both;
      animation-delay: calc(var(--sibling-index) * 200ms);


    }
    .animated-logo__letter2 path{
      animation-name: letterTransformUp2;
      animation-duration: 1s;
      animation-timing-function: linear;
      animation-direction: normal;
      animation-fill-mode: both;
      animation-delay: calc(var(--sibling-index) * 250ms);
    }
  }
  &.down{
    .animated-logo__letter path{
      animation-name: letterTransformUp1;
      animation-duration: 1s;
      animation-timing-function: linear;
      animation-direction: reverse;
      animation-fill-mode: both;
      animation-delay: calc(var(--sibling-index) * 200ms);

    }
    .animated-logo__letter2 path {
      animation-name: letterTransformUp2;
      animation-duration: 1s;
      animation-timing-function: linear;
      animation-direction: reverse;
      animation-fill-mode: both;
      animation-delay: calc(var(--sibling-index) * 250ms);
    }
  }
}

@keyframes letterTransformUp1 {
  from {
    transform: translateY(0%);
    opacity: 1;
  }
  50% {
    transform: translateY(-50%);
    opacity: 0.5;
  }
  to {
    transform: translateY(-100%);
    opacity: 0;
  }
}
@keyframes letterTransformUp2 {
  from {
    transform: translateY(100%);
    opacity: 0;
  }
  50% {
    transform: translateY(50%);
    opacity: 0.5;
  }
  to {
    transform: translateY(0%);
    opacity: 1;
  }
}
@keyframes letterTransformDown1 {
  from {
    transform: translateY(-100%);
    opacity: 0;
  }
  50% {
    transform: translateY(-50%);
    opacity: 0.5;
  }
  to {
    transform: translateY(0%);
    opacity: 1;
  }
}
@keyframes letterTransformDown2 {
  from {
    transform: translateY(0%);
    opacity: 1;
  }
  50% {
    transform: translateY(50%);
    opacity: 0.5;
  }
  to {
    transform: translateY(100%);
    opacity: 0;
  }
}
</style>